var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHotelPicCloseR = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  className: "Modal_closeOutsideButton__joJVQ",
  type: "button",
  "data-aria-hidden": "true",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19.922 3.111a.94.94 0 0 0-.779-.05 1.8 1.8 0 0 0-.63.405c-.96.914-3.265 3.125-6.513 6.355a426 426 0 0 0-6.513-6.355 1.8 1.8 0 0 0-.63-.406.94.94 0 0 0-.779.051c-.17.092-.354.226-.547.42a2.4 2.4 0 0 0-.42.547.94.94 0 0 0-.05.779c.082.238.238.454.405.63.914.96 3.125 3.265 6.355 6.513a425 425 0 0 0-6.355 6.513 1.8 1.8 0 0 0-.406.63.94.94 0 0 0 .051.779c.092.17.226.354.42.547s.378.328.547.42a.94.94 0 0 0 .779.05c.238-.082.454-.238.63-.405A426 426 0 0 0 12 14.179a426 426 0 0 0 6.513 6.355c.176.167.392.323.63.406a.94.94 0 0 0 .779-.051c.17-.092.354-.226.547-.42s.328-.378.42-.547a.94.94 0 0 0 .05-.779 1.8 1.8 0 0 0-.405-.63c-.914-.96-3.125-3.265-6.355-6.513a425 425 0 0 0 6.355-6.513c.167-.176.323-.392.405-.63a.94.94 0 0 0-.05-.779 2.4 2.4 0 0 0-.42-.547 2.4 2.4 0 0 0-.547-.42",
  fill: "#fff"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgHotelPicCloseR);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/hotel-pic-close-r.faf5ed09b693748f0214fc5ee6073f3c.svg";